import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OrganizationModel } from '@smarttask-common/src/lib/models/Organization/OrganizationModel';
import { DateService } from '@smarttask-common/src/lib/services/General/date.service';

@Injectable({
    providedIn: 'root',
})
export class OrganizationUIService {
    constructor(
        private router: Router,
        private dateService: DateService,
    ) {}

    organizationReceivedProcessing = (organization: OrganizationModel) => {
        organization.created_at = this.dateService.serverDateTimeToLocal(organization.created_at);
        organization.subscription.expires_at = this.dateService.serverDateTimeToLocal(organization.subscription.expires_at);
        organization.subscription.grace_expires_at = this.dateService.serverDateTimeToLocal(organization.subscription.grace_expires_at);
        organization.subscription.credits_reset_at = this.dateService.serverDateTimeToLocal(organization.subscription.credits_reset_at);
        return organization;
    };
}
